import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import EnhancedPortfolio from './pages/EnhancedPortfolio';
import { portfolioData as leadSoftwareData }  from './data/mockLeadSoftware';
import { portfolioData as leadFullstackData } from './data/mockLeadFullstack';
import { portfolioData as srSoftwareData }    from './data/mockSrSoftware';
import { portfolioData as srGolangData }      from './data/mockSrGolang';
import { portfolioData as androidData }       from './data/mockAndroid';

const HASH_LEAD_SOFTWARE  = process.env.REACT_APP_ACCESS_TOKEN_HASH_LEAD_SOFTWARE;
const HASH_LEAD_FULLSTACK = process.env.REACT_APP_ACCESS_TOKEN_HASH_LEAD_FULLSTACK;
const HASH_SR_SOFTWARE    = process.env.REACT_APP_ACCESS_TOKEN_HASH_SR_SOFTWARE;
const HASH_SR_GOLANG      = process.env.REACT_APP_ACCESS_TOKEN_HASH_SR_GOLANG;
const HASH_ANDROID        = process.env.REACT_APP_ACCESS_TOKEN_HASH_ANDROID;

async function sha256(message) {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0')).join('');
}

function AccessGuard({ children }) {
  const [state, setState] = useState({ status: 'checking', data: null });
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('access');
    if (!token) { setState({ status: 'denied', data: null }); return; }

    sha256(token).then(hash => {
      if (hash === HASH_LEAD_SOFTWARE)       setState({ status: 'granted', data: leadSoftwareData });
      else if (hash === HASH_LEAD_FULLSTACK) setState({ status: 'granted', data: leadFullstackData });
      else if (hash === HASH_SR_SOFTWARE)    setState({ status: 'granted', data: srSoftwareData });
      else if (hash === HASH_SR_GOLANG)      setState({ status: 'granted', data: srGolangData });
      else if (hash === HASH_ANDROID)        setState({ status: 'granted', data: androidData });
      else                                   setState({ status: 'denied', data: null });
    });
  }, [location.search]);

  if (state.status === 'checking') {
    return <div className="min-h-screen bg-slate-950" />;
  }

  if (state.status === 'denied') {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center px-6">
        <div className="text-center space-y-4">
          <p className="text-8xl font-bold text-slate-700">403</p>
          <h1 className="text-2xl font-semibold text-white">Access Denied</h1>
          <p className="text-slate-400">You do not have access to view this page.</p>
        </div>
      </div>
    );
  }

  return React.cloneElement(children, { portfolioData: state.data });
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/view" element={
            <AccessGuard>
              <EnhancedPortfolio />
            </AccessGuard>
          } />
          {/* Redirect root to /view preserving query params */}
          <Route path="/" element={<RootRedirect />} />
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

function RootRedirect() {
  const location = useLocation();
  return <Navigate to={`/view${location.search}`} replace />;
}

export default App;
